
export default [
  {
    "title": "Letting AI do the heavy reading",
    "description": "The core skill. Prompts and workflows that turn thousands of links into a short, useful briefing you can act on the same afternoon.",
    "module": "Module 02 · The workflow",
    "order": 4,
    "duration": "26 min",
    "draft": false,
    "image": "/img/og/letting-ai-do-the-reading.png",
    "slug": "letting-ai-do-the-reading",
    "readingTime": "1 min read"
  },
  {
    "title": "Pulling any competitor's profile",
    "description": "Hands-on practice. Pull a full list of sites linking to any competitor and clean it into something you can actually work with, in minutes.",
    "module": "Module 02 · The workflow",
    "order": 3,
    "duration": "18 min",
    "draft": false,
    "image": "/img/og/pulling-a-competitor-profile.png",
    "slug": "pulling-a-competitor-profile",
    "readingTime": "1 min read"
  },
  {
    "title": "Reading DR without fear",
    "description": "Domain Rating looks intimidating and gets over-trusted. Here's what it actually measures, and how to use it as a rough sort order rather than gospel.",
    "module": "Module 01 · Foundations",
    "order": 2,
    "duration": "14 min",
    "draft": false,
    "image": "/img/og/reading-dr-without-fear.png",
    "slug": "reading-dr-without-fear",
    "readingTime": "1 min read"
  },
  {
    "title": "Why competitor links are a map",
    "description": "The mindset shift that makes everything else easy. A rival's backlink profile is a to-do list someone already tested and paid for.",
    "module": "Module 01 · Foundations",
    "order": 1,
    "duration": "22 min",
    "draft": false,
    "image": "/img/og/why-competitor-links-are-a-map.png",
    "slug": "why-competitor-links-are-a-map",
    "readingTime": "1 min read"
  }
]